import React from "react";

const categorias = [
  {
    nombre: "Cafetería",
    key: "cafeteria",
    imagen: "https://i.imgur.com/J5pzVym.jpeg",
  },
  {
    nombre: "Desechables",
    key: "desechables",
    imagen: "https://i.imgur.com/n2Pipep.jpeg",
  },
  {
    nombre: "Limpieza",
    key: "limpieza",
    imagen: "https://i.imgur.com/RKqUwKU.jpeg",
  },
  {
    nombre: "Protección Personal",
    key: "proteccion personal",
    imagen: "https://i.imgur.com/4FKOUOJ.jpeg",
  },
  {
    nombre: "Seguridad Industrial",
    key: "seguridad industrial",
    imagen: "https://i.imgur.com/gYECavw.png",
  },
  {
    nombre: "Insumos para Desechos",
    key: "insumos descartables",
    imagen: "https://i.imgur.com/CMt6Q2u.png",
  },
  {
    nombre: "Línea institucional",
    key: "linea institucional",
    imagen: "https://i.imgur.com/PwbDko5.jpeg",
  },
  {
    nombre: "Paños de limpieza",
    key: "Kimberly Clark",
    imagen: "https://i.imgur.com/bDDT8Ac.jpeg",
  },
  {
    nombre: "Hogar",
    key: "Hogar",
    imagen: "https://i.imgur.com/zyQpVMw.png",
  },
];

const scrollToProducts = (offset = 80) => {
  if (!productosRef?.current) return;
  const top = productosRef.current.getBoundingClientRect().top + window.scrollY - offset;
  window.scrollTo({ top, behavior: "smooth" });
};
export default function CategoriasGrid({ onCategoryChange, currentCategory, productosRef }) {
  return (
    <div className="flex justify-center px-4">
      <div className="flex flex-wrap justify-center gap-4 mb-6 max-w-6xl w-full mx-auto">
        {categorias.map((cat) => (
          <div
            key={cat.key}
            className="w-[calc(50%-8px)] sm:w-[calc(33.333%-10.666px)] md:w-[calc(25%-12px)] lg:w-[calc(20%-12.8px)] xl:w-[calc(16.666%-13.333px)]"
          >
            <button
              onClick={() => {
                onCategoryChange(cat.key);
                setTimeout(() => scrollToProducts(80), 150);
              }}
              className={`relative group overflow-hidden rounded-xl shadow-md w-full h-36 sm:h-40 md:h-44 transition-transform duration-300 hover:scale-[1.03] border ${
                currentCategory.trim().toLowerCase() === cat.key.trim().toLowerCase() && cat.key !== ""
                  ? "ring-2 ring-sky-500 border-sky-300"
                  : "border-gray-100 hover:border-sky-200"
              } bg-white`}   // fondo por si sobra espacio
            >
              {/* Imagen completa sin recorte */}
              <img
                src={cat.imagen}
                alt={cat.nombre}
                loading="lazy"
                className="absolute inset-0 w-full h-full object-contain"
              />
            
              {/* Overlay y etiqueta */}
              <div className="absolute inset-0 bg-black/10 group-hover:bg-black/5 transition duration-300" />
              <div
                className="absolute bottom-2 left-1/2 -translate-x-1/2 px-3 py-1 
                bg-white/85 backdrop-blur-md text-sm font-semibold text-gray-800 
                rounded-lg shadow-md text-center leading-snug max-w-[90%] 
                whitespace-normal break-words"
              >
                {cat.nombre}
              </div>
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}

